import { Component } from "@angular/core";
import { PortalService } from "../services/portal-service.service";
import { ShellService } from "../services/shell.service";

@Component({
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  standalone: false,
})
export class DashboardComponent {
  constructor(
    private shellService: ShellService,
    private portalService: PortalService,
  ) {}

  quickLinks = [
    {
      id: "home-card-view-licenses",
      title: "View Licenses",
      description: "Inspect active, expired, and surrendered licenses for the selected contract.",
      icon: "vpn_key",
      route: "/licenses",
      queryParams: { tab: "view" },
    },
    {
      id: "home-card-activate",
      title: "Activate Licenses",
      description: "Create new license activations for physical, virtual, and desktop systems.",
      icon: "task_alt",
      route: "/licenses",
      queryParams: { tab: "activate" },
    },
    {
      id: "home-card-surrender",
      title: "Surrender Licenses",
      description: "Return active licenses and review surrender allowances on your contracts.",
      icon: "keyboard_return",
      route: "/licenses",
      queryParams: { tab: "surrender" },
    },
    {
      id: "home-card-tokens",
      title: "Request Tokens",
      description: "Request tokens for supported contracts.",
      icon: "token",
      route: "/licenses",
      queryParams: { tab: "request-tokens" },
    },
    {
      id: "home-card-downloads",
      title: "Downloads",
      description: "Browse the latest and archived software, ISOs, documentation, and bundles.",
      icon: "download",
      route: "/downloads",
      queryParams: { tab: "latest" },
    },
    {
      id: "home-card-account",
      title: "My Account",
      description: "Update account details, password, reset question, and linked contracts.",
      icon: "person",
      route: "/account",
      queryParams: { tab: "details" },
    },
  ];

  get visibleQuickLinks() {
    const contract = this.shellService.selectedContract;
    if (!contract) return this.quickLinks;

    return this.quickLinks.filter((item) => {
      if (item.queryParams?.tab === "activate") return !this.portalService.disableActivateTab(contract);
      if (item.queryParams?.tab === "surrender") return !this.portalService.disableSurrenderTab(contract);
      if (item.queryParams?.tab === "request-tokens") return !this.portalService.disableTokenTab(contract);
      return true;
    });
  }

  async refresh(): Promise<void> {
    await this.shellService.populateContracts();
  }
}
